export const ua = {
    "title": "Планувальник подій",
    "my-events": "Мої події",
    "more-info": "Детальніше...",
    "add-event-btn": "Додати подію",
    "create-event": "Створити нову подію",
    "create-event-title": "Заголовок",
    "create-event-description": "Опис",
    "create-event-date": "Оберіть дату",
    "create-event-time": "Оберіть час",
    "create-event-location": "Місце",
    "create-event-image": "Оберіть зображення",
    "image-placeholder": "Обрати",
    "create-event-category": "Категорія",
    "create-event-priority": "Пріорітет",
    "create-event-btn": "Додати подію",
    "go-back": "Назад",
    "delete-event": "Видалити подію",
    "at": "о",
    "select-date": "Обрати",
    "search-input": "Шукати по імені",
    "not-selected": "Не обрано",
}